import types from "./types";

const initialState = {
  coachingDataList:[],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case types.COACHING_LIST_RESPONSE:
      return {
        ...state,
        coachingDataList: action.payload,
      };
    case types.COACHING_LIST_CLEAR:
      return {
        ...state,
        coachingDataList: [],
      };    
    default:
      return state;
  }
};